import React, { useEffect, useState } from "react";
import "./MinutesGoals.css";
import ScaleRuler from "./Sliders/ScaleRuler";

interface TherapyDurationSliderProps {
  minValue?: number;
  maxValue?: number;
  defaultValue?: number;
  step?: number;
  onChange?: (value: number) => void;
  primaryColor?: string;
  labelBackgroundColor?: string;
  tickMarks?: number;
}

const TherapyDurationSlider: React.FC<TherapyDurationSliderProps> = ({
  minValue = 0,
  maxValue = 69,
  defaultValue = 10,
  step = 1,
  onChange,
  primaryColor = "#00A9CE",
  labelBackgroundColor = "#E5F7FB",
  tickMarks = 6,
}) => {
  const [value, setValue] = useState<number>(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const formatMinutes = (val: number): string => {
    if (val === 0) return "0 mins";
    return `${val}`;
  };

  // Format labels for the ruler
  const formatLabel = (val: number): string => {
    if (val === 0) return "0";
    return `${val}`;
  };

  return (
    <div className="therapy-duration-container">
      <div className="slider-track-container" style={{ paddingBottom: "50px" }}>
        <ScaleRuler
          minValue={minValue}
          maxValue={maxValue}
          value={value}
          step={step}
          majorStep={10}
          minorStep={5}
          labelInterval={5}
          width={320}
          height={80}
          tickSpacing={18}
          activeColor="#7BD2EC"
          formatValue={formatMinutes}
          formatLabel={formatLabel}
          onChange={(v) => {
            setValue(v);
            if (onChange) {
              onChange(v);
            }
            
          }}
          // helperText="Drag to set your daily therapy minutes"
        />
      </div>
      <div className="flex flex-row justify-center items-center h-[30px] ">
        {/* <span className="text-md">Mins per day</span> */}
      </div>
    </div>
  );
};

export default TherapyDurationSlider;
